import { render, staticRenderFns } from "./DocEditor.vue?vue&type=template&id=31cabc87&scoped=true"
import script from "./DocEditor.vue?vue&type=script&lang=js"
export * from "./DocEditor.vue?vue&type=script&lang=js"
import style0 from "./DocEditor.vue?vue&type=style&index=0&id=31cabc87&prod&scoped=true&lang=css"
import style1 from "./DocEditor.vue?vue&type=style&index=1&id=31cabc87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cabc87",
  null
  
)

export default component.exports